import { useActivateFilter } from '../../hooks/useActivateFilter'
import { useTranslation } from 'react-i18next'

import type { ColorScheme } from '@hivewatch/dark'
import { Box, Modal } from '@hivewatch/dark'

import { MODAL_Z_INDEX } from '@/styles/theme'

import { SavedFilterI } from '../../types/generic'

interface DarkDeactivateFilterConfirmationModalIProps {
  isOpen: boolean
  onClose: () => void
  activeFilter: SavedFilterI
  onApplyFilters: () => void
  colorScheme: ColorScheme
}

export const DarkDeactivateFilterConfirmationModal = ({
  isOpen,
  onClose,
  activeFilter,
  onApplyFilters,
  colorScheme,
}: DarkDeactivateFilterConfirmationModalIProps) => {
  const { t } = useTranslation()
  const { onDeactivateFilter, isDeactivateLoading } = useActivateFilter()

  const handleSave = async () => {
    try {
      await onDeactivateFilter(activeFilter)
      onApplyFilters()
      onClose()
    } catch {
      // The deactivate mutation failure is reported by the Apollo error link;
      // closing keeps parity with the legacy modal.
      onClose()
    }
  }

  return (
    <Modal
      colorScheme={colorScheme}
      isOpen={isOpen}
      isSaveLoading={isDeactivateLoading}
      onClose={onClose}
      onSave={handleSave}
      saveButtonLabel={t('common:apply_filters')}
      showCancelButton
      size='compact'
      title={t('incidents:filter_confirm_application_title')}
      zIndex={MODAL_Z_INDEX}
    >
      <Box mb='12px'>{t('incidents:filter_confirm_application_body1')}</Box>
      <Box>{t('incidents:filter_confirm_application_body2')}</Box>
    </Modal>
  )
}
